import {useCallback} from 'react';
import debounce from "lodash.debounce";

export const useSearchInputChangeHandler = (
    setDebouncedSearchQuery: (inputValue: string) => void,
    delay = 500
) =>
    useCallback(
        debounce((inputValue) => {
            setDebouncedSearchQuery(inputValue);
        }, delay),
        []
    );